import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-restore-petition',
		path: '/dashboard/restore_petition',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_restorePetition" */ './index'), {
			exportName: 'RestorePetition',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
